"use client";

import { useTranslation } from "next-i18next";
import { setProductAttrSelectVisible } from "@/store/mobilePopup";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { RootState } from "@/store/index";
import { ProductNum } from "@/components/MallDetail/ProductInfo";
import ProductAttr from "@/components/MallDetail/ProductAttr/Index";
import ProductActionButtons from "@/components/MallDetail/ProductActionButtons";
import { IAttr, IProductInfo } from "@/props/IProduct";
import { useMemo } from "react";
import Icon from "@/components/Icon";
import { Popup } from "@/components/antd-mobile";

/**
 * product specification popup component
 * @param product product info
 * @param specStock multi-specification product stock
 * @param specPrice multi-specification product price
 * @param attrId product specification id
 * @param cartNum product quantity
 * @param stock product stock
 * @param attrs product specifications
 * @param attrSelect selected product specifications object
 * @param attrSelectArr selected product specifications array
 * @param updateCartNum update product quantity
 */
const MobileAttrPopup = ({
  product,
  specStock = 0,
  specPrice,
  attrId,
  cartNum,
  stock,
  attrs,
  attrSelect,
  attrSelectArr,
  updateCartNum,
  getCurSpecStock,
  onSpecChange,
}: {
  product?: IProductInfo;
  specStock: number;
  specPrice: number;
  attrId?: number;
  cartNum: number;
  stock: number;
  attrs: IAttr[];
  attrSelect: object;
  attrSelectArr: string[];
  updateCartNum: (cartNum: number) => void;
  getCurSpecStock: (attrName: string, item: any) => number;
  onSpecChange: (attrName: string, spec: any) => void;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { productAttrSelectVisible } = useAppSelector(
    (state: RootState) => state.mobilePopup
  );

  /**
   * open or close popup
   * @param visible boolean popup visible
   */
  const handlePopupVisible = (visible: boolean) => {
    dispatch(setProductAttrSelectVisible(visible));
  };

  // popup title
  // 这样可以避免close icon的重新渲染导致的闪动
  // eslint-disable-next-line react/display-name
  const PopupTitle = useMemo(() => {
    return (
      <div className="flex items-center justify-between border-b border-gray-100 py-4">
        <div className="font-stone-800 text-base font-semibold">
          {t("mobile.select_configurations")}
        </div>
        <Icon
          name="close"
          isMobile
          size={24}
          onClick={() => handlePopupVisible(false)}
        />
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // selects product specifications
  const SelectedAttrs = () => {
    return (
      <div className="mt-4 flex items-center ">
        <div className="mr-4 flex-shrink-0">{t("mobile.selected")}:</div>
        {attrSelectArr && attrSelectArr.length > 0 ? (
          <div>
            {attrSelectArr.map(
              (attr, attrIndex) =>
                `${attr}${attrIndex < attrSelectArr.length - 1 ? "; " : ""}`
            )}
          </div>
        ) : (
          <div className=" text-stone-100">
            {t("product_detail.please_select_product_info")}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="block lg:hidden">
      <Popup
        visible={productAttrSelectVisible}
        onMaskClick={() => {
          handlePopupVisible(false);
        }}
        onClose={() => {
          handlePopupVisible(false);
        }}
        position="bottom"
        bodyStyle={{
          width: "100vw",
          height: "77vh",
        }}
      >
        <div className="flex h-full w-full flex-col px-mobile text-stone-800">
          {/* <PopupTitle /> */}
          {PopupTitle}
          <div className="flex flex-1 flex-col overflow-y-auto pb-20">
            <SelectedAttrs />
            <ProductNum
              value={cartNum}
              max={stock}
              updateCartNum={updateCartNum}
              isMobile={true}
            />
            <ProductAttr
              attrs={attrs}
              attrSelect={attrSelect}
              isMobile={true}
              getCurSpecStock={getCurSpecStock}
              onSpecChange={onSpecChange}
            />
          </div>

          <ProductActionButtons
            product={product}
            specStock={specStock}
            specPrice={specPrice}
            attrId={attrId}
            cartNum={cartNum}
            isInPopup={true}
          />
        </div>
      </Popup>
    </div>
  );
};

export default MobileAttrPopup;
